export const formatNotifications = (notifications) => {
  if (!notifications?.length) return '';
  return notifications.map(item => {
    const description = item.description?.trim();
    const meaning = item.meaning
      ?.replace(/\n\s*-/g, '\n• ')  // Chuyển dấu gạch ngang thành bullet points
      ?.replace(/([.!?])\s+/g, '$1\n') // Tách câu riêng biệt
      ?.trim() || 'Phân tích chi tiết đang được cập nhật';
    
    return `▸ **${item.code}** ${description ? `(${description})` : ''}\n${meaning}`;
  }).join('\n\n');
};

export const formatGhiChu = (warnings) => {
  if (!warnings?.length) return '';
  return warnings.map(item => {
    const isSpecial = item.title.includes('nhiều 0');
    const title = item.title.trim();
    const description = item.description.trim();
    
    return isSpecial
      ? `⚠️ **${title}**: ${description} - Cảnh báo đặc biệt cần xem xét kỹ lưỡng`
      : `ℹ️ **${title}**: ${description}`;
  }).join('\n\n');
};

export const formatNumberPairs = (pairs) => {
  if (!pairs?.length) return 'Không phát hiện tổ hợp đặc biệt';
  return pairs.map(pair => {
    const hexagramInfo = pair.hexagramMeaning
      ?.replace(/([.!?])\s+/g, '$1\n') // Tách câu riêng biệt
      ?.trim();
    
    return `▸ **${pair.pair}** (quẻ ${pair.hexagram})\n${hexagramInfo}`;
  }).join('\n\n');
};

export const formatEnergyDetails = (pairs) => {
  if (!pairs?.length) return 'Không xác định được dòng chảy năng lượng';
  
  const items = pairs.map(p => `${p.number} (${p.energy})`);
  if (items.length === 1) return `Bắt đầu và kết thúc với **${items[0]}**`;
  
  return items.slice(0, -1).join(', ') + ` và cuối cùng là **${items[items.length-1]}**`;
};

export const formatCombinedPairs = (pairs) => {
  if (!pairs?.length) return '';
  return pairs.map(pair => {
    const meaning = pair.meaning?.split('\n').map(line => 
      line.trim().replace(/^-/, '').replace(/:/, ': ')
    ).join(' ') || 'Ý nghĩa chuyên sâu đang được hoàn thiện';
    return `**${pair.number}** (${pair.energy}): ${meaning}`;
  }).join('\n\n');
};
